import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const NetellerIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_149016)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#83BA3B"
        />
        <path
          d="M28.3322 14.3072C28.006 14.103 27.5122 14 26.8651 14H25.1702L24.54 17.1256H22.3197L22.4624 16.4165H23.7999L23.9584 15.62L22.6216 15.6218L22.7648 14.9158H24.1424L24.3258 14.0002H21.5279L20.9298 16.965H19.903L20.5052 14.0001H19.0427L18.4445 16.9649H17.4443L18.0471 14.0001H16.5854L15.9545 17.1256H13.7181L13.8595 16.4165H15.2024L15.3611 15.6246L14.0194 15.6234L14.1618 14.916H15.555L15.7371 14H7.01855L6.52231 16.4768L5.53403 14H4.01663L3.19995 18.0421H4.64907L5.14343 15.497L6.10239 18.0421H11.296L11.9274 14.9156H12.7397L12.1082 18.0421H25.7736L26.1698 16.0685L26.8107 18.0421H28.2606L27.5965 16.4294L27.7484 16.3996C28.0831 16.334 28.3441 16.1932 28.5259 15.9822C28.7074 15.7692 28.8 15.4957 28.8 15.1672C28.8 14.7848 28.6468 14.5035 28.3318 14.307L28.3322 14.3072ZM10.0349 17.1256H7.81667L7.95995 16.4165H9.35135L9.50907 15.6178H8.13107L8.26379 14.916H10.4788L10.0345 17.1256L10.0349 17.1256ZM27.1375 15.7641C26.9918 15.8572 26.7804 15.9026 26.4913 15.9026H26.2047L26.4245 14.8179H26.6353C26.8754 14.8179 27.0504 14.853 27.1712 14.9247C27.2654 14.981 27.3776 15.0922 27.3776 15.3026C27.3772 15.557 27.2468 15.6938 27.1372 15.7641L27.1375 15.7641Z"
          fill="white"
        />
      </g>

      <defs>
        <clipPath id="clip0_2177_149016">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
